// extracted by mini-css-extract-plugin
module.exports = {"multiCam":"MultiCam_multiCam__a7BEG","camAdPlayer":"MultiCam_camAdPlayer__yFoQM","hidden":"MultiCam_hidden__A5H0T","camOverlayButton":"MultiCam_camOverlayButton__qjRXk"};